import { useCallback } from 'react';

/**
 * Hook for preloading images to ensure they're cached in the browser
 */
export const useImagePreloader = () => {
  const preloadImage = useCallback(async (url: string): Promise<void> => {
    if (!url) throw new Error('URL is required for preloading');

    return new Promise((resolve, reject) => {
      const img = new Image();
      img.onload = () => resolve();
      img.onerror = () => reject(new Error(`Failed to preload image: ${url}`));
      img.src = url;
    });
  }, []);

  return { preloadImage };
};